export const isGroupHeader = (item: object) => Object.hasOwn(item, 'group');
